import { SvgIcon } from "@mui/material"

import { ReactComponent as Safety } from "./Safety.svg"

export const SafetyIcon = (props) => {
    return (
        <SvgIcon component={Safety} {...props} inheritViewBox />
    )
}